import React, { useState } from 'react';
import './LoadManagement.css';
import LoadTable from '../../components/LoadTable/LoadTable';
import InteractionCapture from '../../components/InteractionCapture/InteractionCapture';

const initialLoads = {
  reloads: [
    { id: 'RL-001', origin: 'Chicago, IL', destination: 'Dallas, TX', pickupDate: '2024-11-22', rate: 1800 },
  ],
  backhauls: [
    { id: 'BH-001', origin: 'Dallas, TX', destination: 'Chicago, IL', pickupDate: '2024-11-25', rate: 1500 },
  ],
  postBooking: [],
};

const LoadManagement = () => {
  const [loads, setLoads] = useState(initialLoads);

  const handleInteractionUpdate = (interaction) => {
    // Simulate real-time update based on interaction
    if (interaction.rejectionReason.toLowerCase().includes('pork')) {
      // Remove loads with pork
    }
    if (interaction.newCapacity.toLowerCase().includes('2 p.m.')) {
      // Find new loads available after 2 p.m.
      const newPostBookingLoad = { id: 'PB-001', origin: 'Dallas, TX', destination: 'Atlanta, GA', pickupDate: '2024-11-25', rate: 2200 };
      setLoads(prevLoads => ({
        ...prevLoads,
        postBooking: [newPostBookingLoad],
      }));
    }
  };

  return (
    <div className="load-management-page">
      <h1>Active Load Management</h1>
      <InteractionCapture onUpdate={handleInteractionUpdate} />
      <LoadTable title="Available Reloads" loads={loads.reloads} />
      <LoadTable title="Available Backhauls" loads={loads.backhauls} />
      <LoadTable title="Post-Booking Loads" loads={loads.postBooking} />
    </div>
  );
};

export default LoadManagement;